import React, { useEffect, useState } from 'react'
import styles from './App.module.css'
import { Route, Routes, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import Home from './components/Home/Home';
import Brands from './components/Brands/Brands';
import Services from './components/Services/Services';
import Products from './components/Products/Products';
import { ServicesType } from './utils/Types/ServicesTypes';
import Contacts from './components/Contacts/Contacts';
import Sazuli from './components/Sazuli/Sazuli';
import ProductInfo from './components/Products/ListProducts/ProductInfo/ProductInfo';
import Termos from './components/Termos/Termos';
import Cookies from './components/Cookies/Cookies';

const App = () => {

    const location = useLocation();
    const [services, setServices] = useState<ServicesType[]>([]);
    const [currentService, setCurrentService] = useState<number | null>(null);
    const [navBackground, setNavBackground] = useState(false);
    const [filterProduct, setFilterProduct] = useState<number | null>(() => {
        // Inicializa lendo do localStorage
        const saved = localStorage.getItem("filterProduct");
        return saved ? Number(saved) : null;
    });

    // Sempre que filterProduct mudar, guarda no localStorage
    useEffect(() => {
        if (filterProduct !== null) {
            localStorage.setItem("filterProduct", filterProduct.toString());
        } else {
            localStorage.removeItem("filterProduct");
        }
    }, [filterProduct]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    useEffect(() => {
        window.addEventListener('unhandledrejection', (event) => {
            const reason = event.reason instanceof Error
                ? event.reason
                : new Error(`Unhandled rejection (non-Error): ${JSON.stringify(event.reason)}`)

            console.error('GLOBAL Unhandled rejection:', reason)
        })
    }, []);

    return (
        <div className={styles.container}>
            <Navbar location={location} services={services} setServices={setServices} setCurrentService={setCurrentService} navBackground={navBackground} filterProduct={filterProduct} setFilterProduct={setFilterProduct} />
            <Routes>
                <Route path="/" element={<Home setNavBackground={setNavBackground} setFilterProduct={setFilterProduct} />} />
                <Route path="/servicos" element={<Services services={services} setServices={setServices} currentService={currentService} setCurrentService={setCurrentService} setNavBackground={setNavBackground} />} />
                <Route path="/produtos" element={<Products setNavBackground={setNavBackground} filterProduct={filterProduct} setFilterProduct={setFilterProduct} />} />
                <Route path='/produtos/:slug' element={<ProductInfo setNavBackground={setNavBackground} />} />
                <Route path="/parceiros" element={<Brands setNavBackground={setNavBackground} />} />
                <Route path="/contactos" element={<Contacts setNavBackground={setNavBackground} />} />
                <Route path="/politica-de-privacidade" element={<Termos setNavBackground={setNavBackground} />} />
                <Route path='/sazuli' element={<Sazuli setNavBackground={setNavBackground} />} />
                <Route path='/politica-de-cookies' element={<Cookies setNavBackground={setNavBackground} />} />
            </Routes>
            <Footer />
        </div>
    )
}

export default App